<template>
  <div class="mobParentalCon">
    <div class="costContainer" v-loading="loading">
      <!-- <div class="headerCon">
        <div class="left"><van-icon name="arrow-left" @click="$router.push('/mobile/home');" /></div>
        <div class="headerTit">我的假期&调休</div>
        <div class="right">
        </div>
      </div> -->
      <div class="selectCon">
        <el-select v-model="holidayType" placeholder="请选择" size="small" @change="changeHolidayType">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-select style="margin-left: 20px;" v-model="infoFrom.year" placeholder="请选择" size="small"
          @change="changeYear">
          <el-option v-for="item in columns" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <!-- <el-date-picker v-model="infoFrom.year" type="year" placeholder="请选择年份" clearable @change="changeYear"
          size="small">
        </el-date-picker> -->
      </div>

      <div class="main">
        <!--
        <div class="main_text">
          <img class="main_img" src="../../assets/mobParental/icon1.png" alt="">
          <div class="titleR">
            <div class="title_text">总计剩余假期</div>
            <div class="bottom_text" style="margin-top: 4px;">{{ dataList.List8 == 0 ? '--' : dataList.List8 + '小时' }}
            </div>
          </div>
        </div>
        -->
        <div class="main_text" v-if="holidayType == '年假' || holidayType == '全部'">
          <img class="main_img" src="../../assets/mobParental/icon4.png" alt="">
          <div class="titleR">
            <div class="title_text">年假剩余</div>
            <div class="bottom_text" style="margin-top: 4px;">{{ dataList.List2 == '--' ? '--' : dataList.List2 + '小时'
              }}</div>
          </div>
        </div>
        <div class="main_text" v-if="holidayType == '调休' || holidayType == '全部'">
          <img class="main_img" src="../../assets/mobParental/icon2.png" alt="">
          <div class="titleR">
            <div class="title_text">本月可用调休</div>
            <div class="bottom_text" style="margin-top: 4px;">{{ dataList.List3 == '--' ? '--' : dataList.List3 + '小时'
              }}
            </div>
          </div>
        </div>
        <!-- <div class="main_text" v-if="holidayType == '调休' || holidayType == '全部'">
          <img class="main_img" src="../../assets/mobParental/icon3.png" alt="">
          <div class="titleR">
            <div class="title_text">次月生效调休</div>
            <div class="bottom_text" style="margin-top: 4px;">{{ dataList.List4 == '--' ? '--' : dataList.List4 + '小时'
              }}
            </div>
          </div>
        </div> -->
        <div class="main_text" v-if="checkIfParentDay">
          <img class="main_img" src="../../assets/mobParental/icon6.png" alt="">
          <div class="titleR">
            <div class="title_text">育儿假剩余时间</div>
            <div class="bottom_text" style="margin-top: 4px;">{{ parentDays.balance === '--' ? '--' : parentDays.balance + '小时' }} </div>
          </div>
        </div>
        <div class="main_text" v-if="checkIfParentDay">
          <img class="main_img" src="../../assets/mobParental/icon6.png" alt="">
          <div class="titleR">
            <div class="title_text">育儿假截止时间</div>
            <div class="bottom_text" style="margin-top: 4px;">{{ parentDays.effexpirationdate }}</div>
          </div>
        </div>
        <div class="main_text" v-if="holidayType == '年假' || holidayType == '全部'">
          <img class="main_img" src="../../assets/mobParental/icon5.png" alt="">
          <div class="titleR">
            <div class="title_text">年假截止时间</div>
            <div class="bottom_text" style="margin-top: 4px;">{{ dataList.List5 }}</div>
          </div>
        </div>

        <div class="main_text" v-if="holidayType == '调休' || holidayType == '全部'">
          <img class="main_img" src="../../assets/mobParental/icon6.png" alt="">
          <div class="titleR">
            <div class="title_text">调休截止时间</div>
            <div class="bottom_text" style="margin-top: 4px;">{{ dataList.List6 }}</div>
          </div>
        </div>

        <div v-if="holidayType === '育儿假'">
          <div class="footerBtn">
            <span class="hint">*</span>基于您在考勤系统中的记录显示，截止到目前为止,
            
              <span>
                {{ tableData[0]?.currentYear ? tableData[0]?.currentYear : '--' }}年还有 {{ parentDays.balance }} 小时
                ，请于{{ parentDays.effexpirationdate }}前使用,
              </span>
               逾期仍未使用的部分视为自动放弃。
          </div>
        </div>

        <div v-else>

        <div class="footerBtn">
          <span class="hint">*</span>基于您在考勤系统中的记录显示，截止到目前为止,
          <span>{{ tableData[0]?.currentYear ? tableData[0]?.currentYear : '--' }}年还有{{ holidayType == '全部' ? '总计剩余假期' :
      holidayType }}{{
      holidayType == '全部' ? dataList.List8 == 0 ? '--' + '小时' : dataList.List8 + '小时' : holidayType == '年假' ?
        dataList.List2 + '小时' : dataList.List3 + '小时'
    }}，请于{{
        tableData[0]?.expiryDate ? tableData[0]?.expiryDate:'--' }}前使用,</span>
          逾期仍未使用的部分视为自动放弃。
        </div>

        </div>

      </div>


      <!-- <div class="costContent">
        <el-table :data="tableData" style="width: 100%" border :header-cell-style="{ background: '#F7F9FA' }"
          :max-height="windowHeight" v-loading="loading">
          <el-table-column prop="holidayType" label="年度"></el-table-column>
          <el-table-column prop="holidayNum" label="剩余">
            <template slot-scope="{ row }">
              {{ row.holidayNum }}小时
            </template>
</el-table-column>
<el-table-column prop="expiryDate" label="截止日期" show-overflow-tooltip>
</el-table-column>
</el-table>

<div class="footerBtn">
  <span class="hint">*</span>基于您在考勤系统中的记录显示，截止到目前为止,
  <span v-for="(item, index) in baseinfo" :key="index">
    {{ item.currentYear }}年还有<span v-if="holidayType == '年假' || holidayType == '全部'">年假{{ item.leaveBal
      }}小时</span>
    <span v-if="holidayType == '全部'">与</span><span v-if="holidayType == '调休' || holidayType == '全部'">调休{{
      item.otBal
      }}小时</span>，请于{{
    item.expiryDate }}前使用,</span>
  逾期仍未使用的部分视为自动放弃
</div>
</div> -->
    </div>

    <!-- <div class="pageContainer">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="pageData.page" :page-sizes="[10, 20, 50, 80, 100]" :page-size="pageData.pageSize"
            layout="total, prev, pager, next,sizes" :total="total">
          </el-pagination>
        </div> -->

  </div>
</template>

<script>
// import apis from "@/apis/insurance.js";
import api from "@/apis";
import moment from "moment";
import apiLogin from "@/apis";
import "moment/locale/zh-cn";
import { getToken } from "@/utils/cookie";
export default {
  name: "mobVacation",
  data() {
    return {
      parentDays: {
        balance: "--",
        effexpirationdate: "--"
      },
      options: [
        { label: "全部", value: "全部" },
        { label: "年假", value: "年假" },
        { label: "调休", value: "调休" },
        { label: "育儿假", value: "育儿假" },
      ],
      tableData: [],
      childrenNameList: [],
      pageData: {
        page: 1,
        pageSize: 20,
      },
      holidayType: "全部",
      total: 0,
      fileListTwo: [],
      windowHeight: "700",
      loading: false,
      infoFrom: {
        empno: "",
        name: "",
        year: moment().format('YYYY'),
      },
      createdate: "",
      columns: [],
      baseinfo: [],
    };
  },

  computed: {
    checkIfParentDay() {
      const holidayType = this.holidayType;
      const condition = holidayType == '育儿假' || holidayType == '全部';
      return this.parentDays.balance !== '--' && condition;
    },
    //计算假期
    dataList() {
      const List1 = this.tableData[0]?.holidayNum == undefined ? 0 : this.tableData[0]?.holidayNum
      const List7 = this.tableData[1]?.holidayNum == undefined ? 0 : this.tableData[1]?.holidayNum
      const List8 = List1 + List7
      const List2 = this.nullTransformation(this.tableData[0]?.holidayNum)
      const List3 = this.nullTransformation(this.tableData[1]?.holidayNum)
      const List4 = this.nullTransformation(this.tableData[1]?.otBal)
      const List5 = this.nullTransformation(this.tableData[0]?.expiryDate)
      const List6 = this.nullTransformation(this.tableData[1]?.expiryDate)
      return {
        List8,
        List2,
        List3,
        List4,
        List5,
        List6
      };
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.init();
    let token = getToken();
    if (token) {
      this.getList();
    } else {
      this.$bus.$on("processToken", (res) => {
        Promise.resolve(this.getHrToken(res)).then(() => {
          this.getList();
        });
      });
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    //获取时间
    init() {
      api.selectEmployeeWithLeader({ empNo: getToken() }).then((data) => {
        this.createdate = data.data.createdate;
        setTimeout(() => {
          this.initYear();
        }, 500);
      });
    },
    // 处理数据为数字0时，显示为--
    nullTransformation(data, type = "--") {
      if (
        data === null ||
        data === undefined ||
        data === "null%" ||
        data === "undefined%"
      ) {
        return "--";
      }
      // return data ? data : type;
      if (
        typeof data === "string" &&
        data.endsWith("%") &&
        parseFloat(data) === 0
      ) {
        return type;
      }
      // 如果输入是百分比字符串，则直接返回
      else if (typeof data === "string" && data.endsWith("%")) {
        return data;
      }
      // 如果输入是数字0，则返回type
      else if (data == 0) {
        return type;
      }
      // 其他情况，直接返回原始输入
      else {
        return data;
      }
    },

    // 初始化年份
    initYear() {
      const lastYear = moment(new Date()).year();
      const createdate = moment(this.createdate).year();
      let outYear = lastYear - createdate + 1;
      this.columns = [...new Array(outYear).keys()]
        .map((k) => {
          return {
            label: `${lastYear - k}年`,
            value: `${lastYear - k}`,
          };
        })
        .reverse();
      this.columns.push({
        label: "全部",
        value: "全部",
      });
    },
    handleParentDays(data) {
      this.parentDays = data.data.parentDays;
    },
    //获取假期列表
    getList() {
      this.loading = true;
      api
        .selectHolidayRecord({
          empNo: getToken(),
          year: this.infoFrom.year === "全部" ? "all" : this.infoFrom.year,
        })
        .then((data) => {
          const res = data.data.hrLeaveBalanceList;
          this.handleParentDays(data);
          this.tableData = [];
          res.forEach((item) => {
            // if (item.holidayNum != 0) {
            //   this.tableData.push(item);
            // }
            this.tableData.push(item);
          });
          // this.tableData = data.data.hrLeaveBalanceList;
          this.baseinfo = data.data.hrLeaveBalanceObj;
          this.baseinfo.forEach((item) => {
            item.expiryDate = moment(item.expiryDate).format("YYYY年MM月DD日");
          });

          // if (this.holidayType !== "全部") {
          //   this.tableData = this.tableData.filter((item) =>
          //     item.holidayType.includes(this.holidayType)
          //   );
          // }
          this.loading = false;
        });
    },
    //获取表格高度
    handleResize() {
      this.windowHeight = window.innerHeight - 295;
    },
    //获取token&用户信息
    getHrToken(username) {
      return new Promise((resolve) => {
        if (username) {
          let thisname = username;
          if (thisname === "17625010228" || thisname === "17637403245") {
            thisname = "10005038";
          } else if (thisname === "15093054787") {
            thisname = "10005038";
          }

          apiLogin.getUserToken({ username: thisname }).then((data) => {
            const info = data.data;
            window.sessionStorage.hrToken = info.auth_token;
            resolve();
          });
        } else {
          // console.log("未登录");
          resolve();
        }
      });
    },
    //改变类型
    changeHolidayType() {
      this.getList();
    },
    // 切换日期
    changeYear() {
      this.getList();
    },
    // // 每页条数
    // handleSizeChange(val) {
    //   this.pageData.pageSize = val;
    //   this.getList1();
    // },
    // // 当前页
    // handleCurrentChange(val) {
    //   this.pageData.page = val;
    //   this.getList1();
    // },
  },
};
</script>
<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .costContainer {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  .costContainer {
    width: 276px * $zoom;
  }
}

.mobParentalCon {
  width: 100%;
  display: flex;
  justify-content: center;
  height: 100vh;
}

::v-deep {
  .el-table .cell.el-tooltip {
    width: 100% !important;
  }
}

.main {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 0 30px;
}

.main_text {
  width: 100%;
  height: 50px* $zoom;
  display: flex;
  background: #FFFFFF;
  box-shadow: 0px 2px 5px 0px rgba(27, 122, 30, 0.13);
  border-radius: 10px;
  align-items: center;
  margin-top: 40px;


  .main_img {
    width: 30px* $zoom;
    height: 30px* $zoom;
    margin-left: 20px;
  }

  .titleR {
    margin-left: 16PX;

    .title_text {
      font-size: 9px* $zoom;
      color: #999999;
    }

    .bottom_text {
      font-weight: 600;
      font-size: 12px* $zoom;
      color: #22AB6D;
    }

  }

}

.costContainer {
  background-image: url('../../assets/mobParental/mobParental-Bg.png');
  background-repeat: no-repeat;
  background-size: 100% 100vh;
  padding-top: 20px;
  background-color: #fff;
  overflow: auto;

  .headerCon {
    display: flex;
    align-content: center;
    justify-content: space-between;
    border-bottom: 1px solid #ececec;
    padding: 0 20px 15px 20px;

    .left {
      .van-icon {
        font-size: 36px;
      }
    }

    .headerTit {
      font-family: PingFang-SC, PingFang-SC;
      font-weight: 600;
      font-size: 37px;
      color: #282b32;
    }

    .right {
      img {
        width: 36px;
        height: 36px;
      }
    }
  }

  .selectCon {
    // height: 112px;
    // background-color: #fff;
    width: 100%;
    display: flex;
    padding: 0 30px;
    margin-top: 20px;

    ::v-deep {
      .el-input__inner {
        height: 25px *$zoom;
      }

    }

    // ::v-deep {

    //   .el-date-editor.el-input,
    //   .el-date-editor.el-input__inner {
    //     width: 35%;
    //   }

    //   .el-select {
    //     width: 35%;
    //     margin-right: 30px;
    //   }
    // }
  }

  .costContent {
    // height: calc(100vh - 420px);
    // height: 100%;
    overflow-y: auto;
    padding-bottom: 20px;
    background-color: #fff;
  }

  .footerBtn {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 22px;
    color: #7c7c7c;
    margin-top: 20px;
    margin-bottom: 20px;

    .hint {
      color: red;
    }
  }

  .pageContainer {
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
  }
}
</style>
